import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const RealEstateIcon = ({
  width = 25,
  height = 25,
  color = '#96A2C2'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    style={{
      fill: color,
      width: width,
      height: height
    }}
    className="icon icons8-apartment-filled"
  >
    {' '}
    <path d="M 13.5 2 L 3 14 L 3 46 L 24 46 L 24 14 L 13.5 2 z M 36.5 2 L 26 14 L 26 46 L 47 46 L 47 14 L 36.5 2 z M 7 18 L 11 18 L 11 23 L 7 23 L 7 18 z M 16 18 L 20 18 L 20 23 L 16 23 L 16 18 z M 30 18 L 34 18 L 34 23 L 30 23 L 30 18 z M 39 18 L 43 18 L 43 23 L 39 23 L 39 18 z M 7 27 L 11 27 L 11 32 L 7 32 L 7 27 z M 16 27 L 20 27 L 20 32 L 16 32 L 16 27 z M 30 27 L 34 27 L 34 32 L 30 32 L 30 27 z M 39 27 L 43 27 L 43 32 L 39 32 L 39 27 z M 7 36 L 11 36 L 11 41 L 7 41 L 7 36 z M 16 36 L 20 36 L 20 41 L 16 41 L 16 36 z M 30 36 L 34 36 L 34 41 L 30 41 L 30 36 z M 39 36 L 43 36 L 43 41 L 39 41 L 39 36 z" />
  </IconSvg>
)

export default RealEstateIcon
